import { render } from "./EmisionRevision.vue?vue&type=template&id=7564d673&scoped=true"
import script from "./EmisionRevision.vue?vue&type=script&lang=js"
export * from "./EmisionRevision.vue?vue&type=script&lang=js"

import "./EmisionRevision.vue?vue&type=style&index=0&id=7564d673&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7564d673"]])

export default __exports__